module["exports"] = [
  "France"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fr/address/default_country.js
// module id = 2306
// module chunks = 2